// frontend/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { SearchContextProvider } from "./lib/searchContext";
import "./index.css";
import App from "./App";
import SignUp from "./pages/SignUp";
import AuthCallback from "./pages/AuthCallback";
import Login from "./pages/Login";
import PostHogProvider from "./providers/PostHogProvider";

// 1. Define our app's pages (routes)
const router = createBrowserRouter([
  { path: "/", element: <App /> },
  { path: "/search", element: <App /> },
  { path: "/signup", element: <SignUp /> },
  { path: "/login", element: <Login /> },
  { path: "/auth/callback", element: <AuthCallback /> },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

// 2. Render the app
root.render(
  <React.StrictMode>
    <AuthProvider>
      <PostHogProvider />
      <SearchContextProvider>
        <RouterProvider router={router} />
      </SearchContextProvider>
    </AuthProvider>
  </React.StrictMode>
);
